import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { MdArticle, MdArticleCondition, MdDetailInspection } from 'models/md/MdArticle';
import { MdBldoCondition, MdBldo } from 'models/md/MdBldo';
import { MdIvesAtcRegCondition, MdIvesAtcReg } from 'models/md/MdIvesActReg';
import { callApi } from 'utils/ApiUtil';

/**
 * 기준정보 > 투자비항목 등록 > 투자비항목 목록 조회
 */
export const findMdIvesAtcRegList = async (condition: MdIvesAtcRegCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/ives-atc`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdIvesAtcReg[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesAtcReg[];
};

/**
 * 기준정보 > 투자비항목 등록 > 투자항목 저장
 */
export const saveMdIvesAtcRegList = async (masterData: MdIvesAtcReg[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/ives-atc`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 기준정보 > 투자비항목 등록 > 사용중인 투자항목 조회
 */
export const findUsedMdIvesAticle = async (masterData: MdIvesAtcReg[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/ives-atc/used`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};
